const STORAGE_KEY = 'oms.ollieOrderingHandoff'
const HANDOFF_TTL_MS = 5 * 60 * 1000

const HOW_TO = /\bhow (do|can|to|does|would|should)\b/i
const WHERE_TO = /^\s*where (do|can|to|should)\b/i
const FAQ_OPENER = /^\s*(what|why|when|can i)\b/i

const DOOR_ONLY =
  /^(please |can you |could you |would you )?(help me )?(to )?(build|make|place|start)\b.{0,50}\border\b[.!?]*$/i

function matchesOrderingDoor(value) {
  return (
    /\bbuild (me |us |my |an |the |a )?(an )?order\b/i.test(value) ||
    /\bmake (me |us )?(an |my |a )?order\b/i.test(value) ||
    /\bstart (an |my |a )?order\b/i.test(value) ||
    /\b(want to|wanna|need to) (place|build|make) (an |a |my )?order\b/i.test(
      value,
    ) ||
    /\bplace (an |my |a )?order with ollie\b/i.test(value) ||
    /\border with ollie\b/i.test(value) ||
    /\b(add|put) .{0,80}\b(in|into|to) (my |the )?basket\b/i.test(value) ||
    /\bi need\s+\d+\b/i.test(value) ||
    /\bget me\s+\d+\b/i.test(value) ||
    /\border me\b/i.test(value) ||
    /\bcan you (build|make|order|add)\b/i.test(value)
  )
}

export function isOllieOrderingHandoffText(text) {
  const value = String(text || '').trim()
  if (!value) return false
  if (HOW_TO.test(value) || WHERE_TO.test(value) || FAQ_OPENER.test(value)) {
    return false
  }
  return matchesOrderingDoor(value)
}

export function ollieOrderingHandoffDraft(text) {
  const value = String(text || '').trim()
  if (!isOllieOrderingHandoffText(value)) return ''
  if (DOOR_ONLY.test(value) && !/\d/.test(value)) return ''
  return value
}

export function ollieOrderingShoppingListsPath(venueId) {
  return `/v/${venueId}/products?ollieOrder=1`
}

export function parseOllieOrderQuery(search) {
  const value = String(search || '')
  const params = new URLSearchParams(
    value.startsWith('?') ? value.slice(1) : value,
  )
  return params.get('ollieOrder') === '1'
}

export function stripOllieOrderSearch(search) {
  const value = String(search || '')
  const params = new URLSearchParams(
    value.startsWith('?') ? value.slice(1) : value,
  )
  params.delete('ollieOrder')
  const next = params.toString()
  return next ? `?${next}` : ''
}

export function storeOllieOrderingHandoff({ venueId, draft } = {}) {
  if (typeof sessionStorage === 'undefined' || !venueId) return
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      venueId: String(venueId),
      draft: String(draft || ''),
      at: Date.now(),
    }),
  )
}

export function consumeOllieOrderingHandoff(venueId) {
  if (typeof sessionStorage === 'undefined' || !venueId) {
    return { open: false, draft: '' }
  }

  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return { open: false, draft: '' }
    const parsed = JSON.parse(raw)
    if (String(parsed.venueId) !== String(venueId)) {
      return { open: false, draft: '' }
    }
    sessionStorage.removeItem(STORAGE_KEY)
    if (Date.now() - Number(parsed.at || 0) > HANDOFF_TTL_MS) {
      return { open: false, draft: '' }
    }
    return { open: true, draft: String(parsed.draft || '') }
  } catch (error) {
    return { open: false, draft: '' }
  }
}

export function beginOllieOrderingHandoff({
  venueId,
  text,
  history,
  closeOllie,
} = {}) {
  if (!venueId || !isOllieOrderingHandoffText(text)) return false
  storeOllieOrderingHandoff({
    venueId,
    draft: ollieOrderingHandoffDraft(text),
  })
  closeOllie?.()
  history?.push(ollieOrderingShoppingListsPath(venueId))
  return true
}
